export const DURATION_PRICE = 10;
